<template>
  <el-dialog
    v-dialogDrag
    :append-to-body="true"
    :visible.sync="dialogVisible"
    :title="title"
    class="small-dialog"
    :before-close="cancel"
    :close-on-click-modal="false"
  >
    <el-row :gutter="10" class="h-full">
      <el-col :span="12" class="h-full">
        <div class="h-full p-20px border-color-default border-1 border-solid">
          <el-input
            placeholder="请输入"
            class="inline-block"
            prefix-icon="el-icon-search"
            v-model="treeKeyword"
            clearable
          />

          <el-tree
            :data="actualTreeData"
            :props="treeProps"
            :node-key="treeNodeKey"
            :default-expanded-keys="treeExpandedKeys"
            highlight-current
            ref="tree"
            class="overflow-y-auto h-[calc(100%-46px)] mt-10px"
            :show-checkbox="!disabled"
            :filter-node-method="filterTree"
            @check="nodeChecked"
          >
            <div
              slot-scope="{ node }"
              class="overflow-x-hidden flex-1 flex items-center justify-between"
            >
              <el-tooltip effect="dark" :content="node.label" placement="top">
                <span class="truncate inline-block tree-item">{{
                  node.label
                }}</span>
              </el-tooltip>
            </div>
          </el-tree>
        </div>
      </el-col>
      <el-col :span="12" class="h-full">
        <div class="h-full p-20px border-color-default border-1 border-solid">
          <el-input
            placeholder="请输入"
            class="inline-block"
            prefix-icon="el-icon-search"
            v-model="selectKeyword"
            clearable
          />
          <div class="text-16px mt-10px">已选择：{{ selectData.length }}</div>
          <div class="h-[calc(100%-72px)] overflow-y-auto mt-10px">
            <div
              v-for="(item, index) in filterSelectData"
              :key="index"
              class="h-24px flex justify-between items-center"
            >
              <span class="flex-1 mr-10px truncate">{{
                item[treeProps.label || 'label']
              }}</span>
              <span
                v-if="
                  !disabled &&
                  !disabledKeys.includes(
                    filterRepeat ? item[repeatKey] : item[treeNodeKey]
                  )
                "
                class="iconfont icon-line-close text-14px cursor-pointer"
                @click="removeItem(item)"
              ></span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div slot="footer" class="text-center" v-if="!disabled">
      <el-button
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="save()"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-save" @click="clear()"
        >清空</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="cancel()"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  uniqBy,
  differenceWith,
  isEqual,
  filter,
  forEach,
  isArray,
  cloneDeep,
  findIndex,
} from 'lodash'

export default {
  name: 'wiz-tree-select',
  props: {
    // 是否禁用操作
    disabled: {
      type: Boolean,
      default: false,
    },
    // 弹窗显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // 树loading
    treeLoading: {
      type: Boolean,
      default: false,
    },
    // 弹窗标题
    title: {
      type: String,
      default: '',
    },
    // 左侧树props
    treeProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 左侧树数据
    treeData: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 左侧树节点唯一标识
    treeNodeKey: {
      type: String,
      default: 'id',
    },
    // 左侧树默认展开节点
    treeExpandedKeys: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 左侧树可以选择树节点字段名称（用于区分哪些树节点可被选择）
    treeCheckField: {
      required: true,
    },
    // 左侧树可以选择树节点字段值（当字段名称不足以区分时可以指定字段值做区分）
    treeCheckValue: {
      default: null,
    },
    // 是否筛选重复数据（如组织机构人员可能存在于多个部门下的情景）
    filterRepeat: {
      type: Boolean,
      default: true,
    },
    // 重复数据标识
    repeatKey: {
      type: String,
      default: 'id',
    },
    // 默认选择数据
    defaultSelectKeys: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 禁用的数据列表（目录树中勾选禁用，已选择列表禁用删除）
    disabledKeys: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      treeKeyword: '',
      selectKeyword: '',
      selectData: [],
      flattenTree: [],
    }
  },
  computed: {
    actualTreeData() {
      if (this.disabledKeys.length) {
        return this.getTreeData(this.treeData)
      }
      return this.treeData
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    filterSelectData() {
      return filter(this.selectData, (item) => {
        return (
          item[this.treeProps.label || 'label'] &&
          item[this.treeProps.label || 'label'].includes(this.selectKeyword)
        )
      })
    },
  },
  watch: {
    treeKeyword(val) {
      this.$refs.tree.filter(val)
    },
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.setDefaultChecked()
        })
      }
    },
    actualTreeData: {
      immediate: true,
      handler(val) {
        if (val.length) {
          this.flattenTree = this.treeToOneArray(
            val,
            this.treeProps.children || 'children'
          )
          this.$nextTick(() => {
            this.setDefaultChecked()
          })
        }
      },
    },
  },
  methods: {
    // 设置禁用
    getTreeData(treeData) {
      const hanldeData = []
      treeData.forEach((item) => {
        const cloneTreeItem = cloneDeep(item)
        if (
          this.disabledKeys.includes(
            this.filterRepeat ? item[this.repeatKey] : item[this.treeNodeKey]
          )
        ) {
          cloneTreeItem.disabled = true
        }
        const childrenKey = this.treeProps.children || 'children'
        if (item[childrenKey] && item[childrenKey].length) {
          cloneTreeItem.children = this.getTreeData(item[childrenKey])
        }
        hanldeData.push(cloneTreeItem)
      })
      return hanldeData
    },
    // 设置默认选中
    setDefaultChecked() {
      if (!this.$refs.tree || this.defaultSelectKeys.length === 0) return
      const checkedData = filter(this.flattenTree, (item) => {
        if (this.filterRepeat) {
          return this.defaultSelectKeys.includes(item[this.repeatKey])
        }
        return this.defaultSelectKeys.includes(item[this.treeNodeKey])
      })
      this.$refs.tree.setCheckedNodes(checkedData)
      if (this.filterRepeat) {
        this.selectData = uniqBy(checkedData, this.repeatKey)
      }
    },
    filterTree(value, data) {
      if (!value) return true
      if (!data[this.treeProps.label || 'label']) {
        return false
      }
      return data[this.treeProps.label || 'label'].includes(value)
    },
    // 树转一维数组
    treeToOneArray(treeData, key) {
      const flattenList = []
      forEach(treeData, (item) => {
        const cloneItem = cloneDeep(item)
        delete cloneItem[key]
        flattenList.push(cloneItem)
        if (isArray(item[key])) {
          const flattenChildren = this.treeToOneArray(item[key], key)
          flattenList.push(...flattenChildren)
        }
      })
      return flattenList
    },
    nodeChecked(data, checkData) {
      const allCheckedNodes = [
        ...checkData.checkedNodes,
        ...checkData.halfCheckedNodes,
      ]
      const isChecked =
        findIndex(allCheckedNodes, (item) => {
          return item[this.treeNodeKey] === data[this.treeNodeKey]
        }) > -1
      // 筛选可选择数据
      let filterCheck = allCheckedNodes.filter((item) => {
        if (this.treeCheckValue) {
          return item[this.treeCheckField] === this.treeCheckValue
        }
        return item[this.treeCheckField] !== undefined
      })
      let repeatData = []
      if (this.filterRepeat) {
        // 过滤重复数据
        repeatData = this.flattenTree.filter((item) => {
          return item[this.repeatKey] === data[this.repeatKey]
        })
        filterCheck = uniqBy(filterCheck, this.repeatKey)
      }
      if (!isChecked) {
        // 设置重复数据取消勾选
        repeatData.forEach((item) => {
          this.$refs.tree.setChecked(item[this.treeNodeKey], false)
        })
        const popList = differenceWith(this.selectData, filterCheck, isEqual)
        this.selectData = differenceWith(this.selectData, popList, isEqual)
      } else {
        // 设置重复数据勾选
        repeatData.forEach((item) => {
          this.$refs.tree.setChecked(item[this.treeNodeKey], true)
        })
        const pushList = differenceWith(filterCheck, this.selectData, isEqual)
        this.selectData = this.selectData.concat(pushList)
      }
    },
    removeItem(item) {
      const key = item[this.treeNodeKey]
      const index = findIndex(this.selectData, (data) => {
        return data[this.treeNodeKey] === key
      })
      this.selectData.splice(index, 1)
      if (this.filterRepeat) {
        const repeatData = filter(this.flattenTree, (data) => {
          return data[this.repeatKey] === item[this.repeatKey]
        })
        repeatData.forEach((data) => {
          this.$refs.tree.setChecked(data[this.treeNodeKey], false)
        })
      } else {
        this.$refs.tree.setChecked(key, false)
      }
    },
    cancel(done) {
      this.treeKeyword = ''
      this.selectKeyword = ''
      this.clear()
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
    save() {
      this.$emit('save', this.selectData)
      this.cancel()
    },
    clear() {
      this.selectData = []
      this.$refs.tree.setCheckedKeys([])
    },
  },
}
</script>

<style></style>
